'use client'

import React, { createContext, useEffect, useState } from 'react'
import throttle from 'lodash.throttle'

const WindowWidthContext = createContext(0)

export function WindowWidthProvider({ children }: { children: React.ReactNode }): JSX.Element {
    const [windowWidth, setWindowWidth] = useState<number | null>(null)

    useEffect(() => {
        const handleResize = throttle(() => {
            const windowWidth = window.innerWidth
            setWindowWidth(windowWidth)
        }, 300)

        window.addEventListener('resize', handleResize)
        handleResize()

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    if (windowWidth === null) {
        return <></>
    }

    return (
        <WindowWidthContext.Provider value={windowWidth} >
            {children}
        </WindowWidthContext.Provider>
    )
}

export default WindowWidthContext
